import React from 'react';
import { UxPerformanceIndicator } from "botbit-ui-components";
import './MetricCard.scss';

const MetricCard = ({ value, label, variation, showVariation = true, t }) => {
    return (
        <div className="metric-card">
            <div className="metric-label">{label}</div>
            <div className="metric-value">{value || 0}</div>
            {showVariation && (
                <div className="metric-variation">
                    {(variation !== undefined && variation !== 0) ? (
                        <div 
                            title={t('columns.comparisonTooltip')}
                            className="variation-container"
                        >
                            <UxPerformanceIndicator value={variation} />
                        </div>
                    ) : (
                        <div 
                            title={t('columns.noDataComparisonTooltip')}
                            className="no-variation"
                        >
                            -
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

const getMetricValue = (store, metric, property) => {
    if (!store || !store.metrics || !store.metrics[metric]) return 0;
    return store.metrics[metric][property];
};

export const MetricsGrid = ({ store, t }) => {
    if (!store) return null;

    return (
        <div className="metrics-grid">
            <MetricCard 
                value={getMetricValue(store, 'visits', 'value')}
                label={t('metrics.visits')}
                variation={getMetricValue(store, 'visits', 'variationPercentage')}
                t={t}
            />
            <MetricCard 
                value={getMetricValue(store, 'walkIns', 'value')}
                label={t('metrics.walkIns')}
                variation={getMetricValue(store, 'walkIns', 'variationPercentage')}
                t={t}
            />
            <MetricCard 
                value={getMetricValue(store, 'websiteClicks', 'value')}
                label={t('metrics.websiteClicks')}
                variation={getMetricValue(store, 'websiteClicks', 'variationPercentage')}
                t={t}
            />
            <MetricCard 
                value={getMetricValue(store, 'orders', 'value')}
                label={t('metrics.orders')}
                variation={getMetricValue(store, 'orders', 'variationPercentage')}
                t={t}
            />
            <MetricCard 
                value={getMetricValue(store, 'bookings', 'value')}
                label={t('metrics.bookings')}
                variation={getMetricValue(store, 'bookings', 'variationPercentage')}
                t={t}
            />
            {store.metrics && store.metrics.engagementRate !== undefined && (
                <MetricCard 
                    value={`${Number(store.metrics.engagementRate || 0).toFixed(2)}%`}
                    label={t('metrics.engagementRate')}
                    showVariation={false}
                    t={t}
                />
            )}
        </div>
    );
};
